(function () {
  'use strict';

  var path = String(window.location.pathname || '').toLowerCase();

  var cardActions = {
    '/pages/fox-suspension-service': {
      'Smashpot, Secus, Luftkappe & Fractive': [
        { label: 'View Fox Smashpot', href: '/products/rockshox-vorsprung-smashpot-fork-coil-conversion-system' },
        { label: 'View Fox Secus', href: '/products/secus-fox-fork-air-spring-upgrade-kit' },
        { label: 'View Fox Luftkappe', href: '/products/vorsprung-luftkappe' },
        { label: 'View Fractive', href: '/products/vorsprung-fractive-tuning-kit' }
      ],
      'Fluid Focus, Bump Stops & Coil Springs': [
        { label: 'View Fluid Focus Piston Kits', href: '/collections/fluid-focus-piston-kits' },
        { label: 'View Bump Stops', href: '/collections/fluid-focus-bump-stops' },
        { label: 'View Split Preload Collars', href: '/collections/fluid-focus-spring-collars' },
        { label: 'View Super Alloy Racing Springs', href: '/collections/rear-shock-springs' },
        { label: 'View Sprindex Springs', href: '/collections/sprindex' }
      ],
      'Damper, Travel & LSC Upgrades': [
        { label: 'Book Damper Upgrade', href: '/pages/book-a-suspension-service' },
        { label: 'Book Travel Change', href: '/pages/book-a-suspension-service' },
        { label: 'View FOX LSC Adjuster', href: '/products/fox-upgrade-lsc-adjuster-2022-float-x-and-dhx' },
        { label: 'Book FOX LSC Adjuster Upgrade', href: '/pages/book-a-suspension-service' }
      ],
      'Fork & Shock Air Volume Spacer Setup': [
        { label: 'View Fork Air Volume Spacers', href: '/collections/brands/products/fox-fork-volume-reducers' },
        { label: 'View Shock Air Volume Spacers', href: '/collections/shock-air-volume-spacers' },
        { label: 'Book Volume Spacer Setup', href: '/pages/book-a-suspension-service' }
      ]
    },

    '/pages/rockshox-suspension-service': {
      'Smashpot, Secus & Luftkappe': [
        { label: 'View RockShox Smashpot', href: '/products/rockshox-smashpot-fork-coil-conversion-system' },
        { label: 'View RockShox Secus', href: '/products/secus-rockshox-fork-air-spring-upgrade-kit' },
        { label: 'View RockShox Luftkappe', href: '/products/vorsprung-rockshox-luftkappe-kits' }
      ],
      'Vivid, Bump Stop, Preload & Spring Upgrades': [
        { label: 'View Fluid Focus Piston Kits', href: '/collections/fluid-focus-piston-kits' },
        { label: 'View Bump Stops', href: '/collections/fluid-focus-bump-stops' },
        { label: 'View Split Preload Collars', href: '/collections/fluid-focus-spring-collars' },
        { label: 'View Super Alloy Racing Springs', href: '/collections/rear-shock-springs' },
        { label: 'View Sprindex Springs', href: '/collections/sprindex' }
      ],
      'Fork Damper & Travel Upgrades': [
        { label: 'Book Damper Upgrade', href: '/pages/book-a-suspension-service' },
        { label: 'Book Travel Change', href: '/pages/book-a-suspension-service' }
      ],
      'Fork & Shock Air Volume Spacer Setup': [
        { label: 'View Fork Air Volume Spacers', href: '/products/rockshox-air-volume-reducers' },
        { label: 'View Shock Air Volume Spacers', href: '/products/rockshox-shox-volume-reducers' },
        { label: 'Book Volume Spacer Setup', href: '/pages/book-a-suspension-service' }
      ]
    },

    '/pages/ohlins-suspension-service': {
      'Smashpot Coil Conversion': [
        { label: 'View Öhlins Smashpot', href: '/products/ohlins-smashpot-fork-coil-conversion-system' },
        { label: 'Book Smashpot Installation', href: '/pages/book-a-suspension-service' }
      ],
      'Air-Shaft Travel Changes': [
        { label: 'Book Travel Change', href: '/pages/book-a-suspension-service' }
      ],
      'Rear Shock Volume Setup': [
        { label: 'Book Volume Spacer Setup', href: '/pages/book-a-suspension-service' }
      ],
      'Bump Stop & Coil Spring Upgrades': [
        { label: 'View Bump Stops', href: '/collections/fluid-focus-bump-stops' },
        { label: 'View Super Alloy Racing Springs', href: '/collections/rear-shock-springs' },
        { label: 'View Sprindex Springs', href: '/collections/sprindex' }
      ]
    },

    '/pages/marzocchi-suspension-service': {
      'Smashpot & Secus': [
        { label: 'View Marzocchi Smashpot', href: '/products/rockshox-vorsprung-smashpot-fork-coil-conversion-system' },
        { label: 'View Marzocchi Secus', href: '/products/secus-fox-fork-air-spring-upgrade-kit' }
      ],
      'Damper & Travel Upgrades': [
        { label: 'Book Damper Upgrade', href: '/pages/book-a-suspension-service' },
        { label: 'Book Travel Change', href: '/pages/book-a-suspension-service' }
      ],
      'Bomber CR Piston, Bump Stop, Preload & Spring Options': [
        { label: 'View Bomber CR Piston Kit', href: '/products/fluid-focus-marzocchi-rear-shock-piston-kits' },
        { label: 'View Bump Stops', href: '/collections/fluid-focus-bump-stops' },
        { label: 'View Split Preload Collar', href: '/products/fluid-focus-coil-rear-shock-split-preload-collar-kit' },
        { label: 'View Super Alloy Racing Springs', href: '/collections/rear-shock-springs' },
        { label: 'View Sprindex Springs', href: '/collections/sprindex' }
      ],
      'Fork & Shock Air Volume Spacer Setup': [
        { label: 'View Fork Air Volume Spacers', href: '/products/marzocchi-fork-air-volume-spacer' },
        { label: 'View Bomber Air Volume Spacers', href: '/products/marzocchi-bomber-air-volume-spacer-kits' },
        { label: 'Book Volume Spacer Setup', href: '/pages/book-a-suspension-service' }
      ]
    },

    '/pages/dvo-suspension-service': {
      'Smashpot Coil Conversion': [
        { label: 'View DVO Smashpot', href: '/products/dvo-smashpot-fork-coil-conversion-system' },
        { label: 'Book Smashpot Installation', href: '/pages/book-a-suspension-service' }
      ],
      'Air-Shaft Travel Changes': [
        { label: 'Book Travel Change', href: '/pages/book-a-suspension-service' }
      ],
      'Volume, Bump Stop & Coil Spring Tuning': [
        { label: 'Book Volume Spacer Setup', href: '/pages/book-a-suspension-service' },
        { label: 'View Bump Stops', href: '/collections/fluid-focus-bump-stops' },
        { label: 'View Super Alloy Racing Springs', href: '/collections/rear-shock-springs' },
        { label: 'View Sprindex Springs', href: '/collections/sprindex' }
      ]
    },

    '/pages/cane-creek-suspension-service': {
      'Cane Creek Air Volume Setup': [
        { label: 'View Cane Creek Volume Spacers', href: '/products/cane-creek-air-volume-spacers' },
        { label: 'Book Volume Spacer Setup', href: '/pages/book-a-suspension-service' }
      ],
      'Bump Stop Upgrades': [
        { label: 'View Bump Stops', href: '/collections/fluid-focus-bump-stops' }
      ],
      'SAR & Sprindex Spring Options': [
        { label: 'View Super Alloy Racing Springs', href: '/collections/rear-shock-springs' },
        { label: 'View Sprindex Springs', href: '/collections/sprindex' }
      ]
    },

    '/pages/ext-suspension-service': {
      'Smashpot for EXT ERA 36': [
        { label: 'View EXT Smashpot', href: '/products/ext-smashpot-v2' },
        { label: 'Book Smashpot Installation', href: '/pages/book-a-suspension-service' }
      ],
      'Super Alloy Racing & Sprindex Coil Springs': [
        { label: 'View Super Alloy Racing Springs', href: '/collections/rear-shock-springs' },
        { label: 'View Sprindex Springs', href: '/collections/sprindex' },
        { label: 'Book EXT Service', href: '/pages/book-a-suspension-service' }
      ]
    },

    '/pages/bos-suspension-service': {
      'Super Alloy Racing & Sprindex Coil Springs': [
        { label: 'View Super Alloy Racing Springs', href: '/collections/rear-shock-springs' },
        { label: 'View Sprindex Springs', href: '/collections/sprindex' },
        { label: 'Book BOS Service', href: '/pages/book-a-suspension-service' }
      ],
      'Fluid Focus Bump Stop for BOS Kirk': [
        { label: 'View Fluid Focus Bump Stops', href: '/products/bump-stops' },
        { label: 'Book BOS Kirk Service', href: '/pages/book-a-suspension-service' }
      ]
    },

    '/pages/manitou-suspension-service': {
      'Smashpot for Mezzer 3': [
        { label: 'View Manitou Smashpot', href: '/products/manitou-smashpot-v2' },
        { label: 'Book Smashpot Installation', href: '/pages/book-a-suspension-service' }
      ]
    },

    '/pages/fast-suspension-service': {
      'FAST SC5 Fork Cartridge': [{ label: 'Book FAST Service', href: '/pages/book-a-suspension-service' }],
      'FAST DC3 for RockShox ZEB': [{ label: 'Book FAST Service', href: '/pages/book-a-suspension-service' }],
      'Super Alloy Racing & Sprindex Coil Springs': [
        { label: 'View Super Alloy Racing Springs', href: '/collections/rear-shock-springs' },
        { label: 'View Sprindex Springs', href: '/collections/sprindex' },
        { label: 'Book FAST Service', href: '/pages/book-a-suspension-service' }
      ],
      'Fluid Focus Bump Stops for FAST Rear Shocks': [
        { label: 'View Fluid Focus Bump Stops', href: '/products/bump-stops' },
        { label: 'Book FAST Service', href: '/pages/book-a-suspension-service' }
      ]
    }
  };

  var additionalCards = {
    '/pages/fox-suspension-service': [
      {
        label: 'FOX OEM performance',
        title: 'Damper, Travel & LSC Upgrades',
        text: 'Factory Fox damper and air-spring travel upgrades are available on selected fork generations, plus the genuine Fox LSC adjuster upgrade for 2022+ FLOAT X and DHX rear shocks.',
        modelsHtml: '<span class="cjs-performance-fitment-row"><b>Forks</b> Selected compatible Fox fork generations</span><span class="cjs-performance-fitment-row"><b>LSC</b> 2022+ FLOAT X / DHX</span>'
      },
      {
        label: 'Air-spring performance',
        title: 'Fork & Shock Air Volume Spacer Setup',
        text: 'Tune air-spring progression, support and bottom-out resistance on compatible Fox forks and air shocks using the correct volume-spacer or reducer configuration for the exact model and generation.',
        modelsHtml: '<span class="cjs-performance-fitment-row"><b>Forks</b> Selected air-sprung Fox 32 / 34 / 36 / 38 / 40 / Podium generations; Fox 831 excluded from this generic setup claim</span><span class="cjs-performance-fitment-row"><b>Air shocks</b> Compatible Float / Float SL / DPS / CTD / RP-series / DPX2 / Float X / Float X2 generations</span>'
      }
    ],
    '/pages/rockshox-suspension-service': [
      {
        label: 'Fork performance',
        title: 'Fork Damper & Travel Upgrades',
        text: 'Complete replacement damper upgrades and air-shaft travel changes are supported on selected RockShox fork generations. Exact compatibility depends on chassis, damper and air-spring generation.',
        models: 'Selected SID / Pike / Lyrik / ZEB / BoXXer / Domain / Yari and compatible legacy families'
      },
      {
        label: 'Air-spring performance',
        title: 'Fork & Shock Air Volume Spacer Setup',
        text: 'Tune air-spring progression, support and bottom-out resistance on compatible RockShox forks and air shocks using the correct Bottomless Token, ring or volume-reducer system for the exact model and generation.',
        modelsHtml: '<span class="cjs-performance-fitment-row"><b>Forks</b> Selected supported SID / Pike / Lyrik / ZEB / BoXXer / Domain / Yari / Revelation / Reba / Psylo and other confirmed air-spring generations</span><span class="cjs-performance-fitment-row"><b>Air shocks</b> SIDLuxe / Deluxe / Super Deluxe Air / Vivid Air / Monarch / Monarch Plus where the correct token, ring or volume-reducer system is supported</span>'
      }
    ],
    '/pages/ohlins-suspension-service': [{
      label: 'Fork performance',
      title: 'Air-Shaft Travel Changes',
      text: 'Air-shaft travel changes are supported on compatible Öhlins RXC34, RXF34, RXF36, RXF38, DH38 and RXFDJ generations after the exact fork specification is confirmed.',
      models: 'RXC34 / RXF34 / RXF36 / RXF38 / DH38 / RXFDJ'
    }],
    '/pages/marzocchi-suspension-service': [{
      label: 'Air-spring performance',
      title: 'Fork & Shock Air Volume Spacer Setup',
      text: 'Tune air-spring progression, support and bottom-out resistance on compatible Marzocchi forks and air shocks using the correct volume-spacer configuration for the exact model and generation.',
      modelsHtml: '<span class="cjs-performance-fitment-row"><b>Forks</b> Bomber Z1 air / Bomber Z2 / Bomber 58 / Bomber DJ / Super Z; factory Bomber Z1 Coil excluded</span><span class="cjs-performance-fitment-row"><b>Air shocks</b> Bomber Air / Bomber Inline</span>'
    }],
    '/pages/ext-suspension-service': [{
      label: 'Rear shock spring options',
      title: 'Super Alloy Racing & Sprindex Coil Springs',
      text: 'Coil spring options for compatible EXT Storia setups, with spring rate and fitment confirmed for the exact shock and bike before installation.',
      models: 'EXT Storia Family'
    }],
    '/pages/bos-suspension-service': [
      {
        label: 'Rear shock spring options',
        title: 'Super Alloy Racing & Sprindex Coil Springs',
        text: 'Coil spring options are available for compatible BOS rear-shock applications. Exact shock, spring dimensions and rate are confirmed before installation.',
        models: 'Compatible BOS coil-shock applications'
      },
      {
        label: 'Fluid Focus rear shock upgrade',
        title: 'Fluid Focus Bump Stop for BOS Kirk',
        text: 'Fluid Focus bump-stop upgrades are supported on compatible BOS Kirk configurations after the exact shock setup and fitment are confirmed.',
        models: 'BOS Kirk Family where compatible'
      }
    ],
    '/pages/fast-suspension-service': [
      {
        label: 'FAST fork cartridge',
        title: 'FAST SC5 Fork Cartridge',
        text: 'The SC5 is a sealed FAST fork cartridge with three independent compression circuits and custom workshop setup. Book the fork service first and CJSUSPENSION will confirm the exact host fork and tune before installation.',
        models: 'Yari 2017+ / Revelation 35 2018+ / Lyrik 35 / Pike 35 2016+ / ZEB & Domain 2022+ / Fox 36 2015+ / Fox 38 / Marzocchi Z1 2019+'
      },
      {
        label: 'FAST ZEB fork upgrade',
        title: 'FAST DC3 for RockShox ZEB',
        text: 'A dedicated FAST performance option for compatible RockShox ZEB forks. Exact ZEB generation, damper configuration and workshop requirements are confirmed before the service is carried out.',
        models: 'Compatible RockShox ZEB configurations'
      },
      {
        label: 'Rear shock spring options',
        title: 'Super Alloy Racing & Sprindex Coil Springs',
        text: 'Coil spring upgrades are available for compatible FAST Fenix, Ride and Holy Grail rear shocks, with spring rate and fitment confirmed during the workshop job.',
        models: 'FAST Fenix / Ride / Holy Grail families'
      },
      {
        label: 'Fluid Focus rear shock upgrade',
        title: 'Fluid Focus Bump Stops for FAST Rear Shocks',
        text: 'Fluid Focus bump-stop upgrades are available for compatible FAST rear shocks to improve bottom-out control. Exact shock configuration is checked before fitment.',
        models: 'FAST Fenix / Ride / Holy Grail where compatible'
      }
    ]
  };

  var headingAliases = {
    '/pages/fox-suspension-service': {
      'Fork Damper & Travel Upgrades': 'Damper, Travel & LSC Upgrades',
      'Air Shock Volume Spacer Setup': 'Fork & Shock Air Volume Spacer Setup',
      'Fork Air Volume Spacer Setup': 'Fork & Shock Air Volume Spacer Setup',
      'Air Volume Spacer Setup': 'Fork & Shock Air Volume Spacer Setup'
    },
    '/pages/rockshox-suspension-service': {
      'Air Shock Volume Spacer Setup': 'Fork & Shock Air Volume Spacer Setup',
      'Fork Air Volume Spacer Setup': 'Fork & Shock Air Volume Spacer Setup',
      'Air Volume Spacer Setup': 'Fork & Shock Air Volume Spacer Setup'
    },
    '/pages/marzocchi-suspension-service': {
      'Air Shock Volume Spacer Setup': 'Fork & Shock Air Volume Spacer Setup',
      'Fork Air Volume Spacer Setup': 'Fork & Shock Air Volume Spacer Setup',
      'Air Volume Spacer Setup': 'Fork & Shock Air Volume Spacer Setup',
      'Bomber CR Piston, Bump Stop & Spring Options': 'Bomber CR Piston, Bump Stop, Preload & Spring Options'
    },
    '/pages/fast-suspension-service': {
      '3 Way, UP & DC3 Upgrade Kits': 'FAST SC5 Fork Cartridge'
    }
  };

  var brandNames = {
    '/pages/ext-suspension-service': 'EXT',
    '/pages/bos-suspension-service': 'BOS',
    '/pages/fast-suspension-service': 'FAST',
    '/pages/manitou-suspension-service': 'Manitou'
  };

  function addStyles() {
    if (document.getElementById('cjs-brand-performance-cta-fix-styles')) return;

    var style = document.createElement('style');
    style.id = 'cjs-brand-performance-cta-fix-styles';
    style.textContent =
      '[data-cjs-brand-performance-upgrades]{padding-top:58px;padding-bottom:58px;border-top:1px solid var(--cjs-border,#e6e2dd);}' +
      '[data-cjs-brand-performance-upgrades] .cjs-brand-page__section-header{margin-bottom:28px;}' +
      '.cjs-brand-performance-upgrades__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:20px;align-items:stretch;}' +
      '.cjs-brand-performance-upgrades__card{display:flex;min-width:0;flex-direction:column;padding:28px;border:1px solid var(--cjs-border,#e6e2dd);border-radius:10px;background:#fff;}' +
      '.cjs-brand-performance-upgrades__label{margin:0 0 10px;color:var(--cjs-accent,#a8323a);font-size:11px;font-weight:800;letter-spacing:.13em;text-transform:uppercase;}' +
      '.cjs-brand-performance-upgrades__card h3{margin:0;color:var(--cjs-text,#111);font-size:22px;font-weight:800;line-height:1.14;letter-spacing:-.025em;}' +
      '.cjs-brand-performance-upgrades__text{margin:13px 0 0;color:var(--cjs-muted,#606060);font-size:14px;line-height:1.62;}' +
      '.cjs-brand-performance-upgrades__models{margin:18px 0 0;padding-top:15px;border-top:1px solid var(--cjs-border,#e6e2dd);color:var(--cjs-muted,#606060);font-size:12px;line-height:1.55;}' +
      '.cjs-brand-performance-upgrades__models strong{color:var(--cjs-text,#111);}' +
      '.cjs-brand-performance-upgrades__actions{display:flex;flex-direction:column;gap:7px;margin-top:auto;padding-top:18px;}' +
      '.cjs-brand-performance-upgrades__actions .cjs-brand-page__card-link{margin-top:0!important;min-height:28px;}' +
      '.cjs-brand-performance-upgrades__actions .cjs-brand-page__card-link+.cjs-brand-page__card-link{padding-top:7px!important;border-top:1px solid var(--cjs-border,#e6e2dd);}' +
      '.cjs-performance-fitment-row{display:block;margin-top:6px;}' +
      '.cjs-performance-fitment-row b{display:inline-block;min-width:72px;color:var(--cjs-text,#111);font-weight:800;}' +
      '@media(max-width:749px){[data-cjs-brand-performance-upgrades]{padding-top:46px;padding-bottom:46px}.cjs-brand-performance-upgrades__grid{grid-template-columns:1fr}.cjs-brand-performance-upgrades__actions{gap:9px;}}';

    document.head.appendChild(style);
  }

  function createCard(config) {
    var card = document.createElement('article');
    card.className = 'cjs-brand-performance-upgrades__card';
    card.setAttribute('data-cjs-added-performance-card', '');

    var label = document.createElement('p');
    label.className = 'cjs-brand-performance-upgrades__label';
    label.textContent = config.label;

    var heading = document.createElement('h3');
    heading.textContent = config.title;

    var text = document.createElement('p');
    text.className = 'cjs-brand-performance-upgrades__text';
    text.textContent = config.text;

    card.appendChild(label);
    card.appendChild(heading);
    card.appendChild(text);

    if (config.models || config.modelsHtml) {
      var models = document.createElement('p');
      models.className = 'cjs-brand-performance-upgrades__models';
      models.innerHTML = '<strong>Confirmed range:</strong>' + (config.modelsHtml ? config.modelsHtml : ' ' + config.models);
      card.appendChild(models);
    }

    return card;
  }

  function ensurePerformanceSection() {
    var section = document.querySelector('[data-cjs-brand-performance-upgrades]');
    if (section) return section;
    if (!additionalCards[path] || !additionalCards[path].length) return null;

    var page = document.querySelector('.cjs-brand-page');
    if (!page) return null;

    var content = page.querySelector('.cjs-brand-page__content');
    if (!content) return null;

    section = document.createElement('section');
    section.className = 'cjs-brand-page__products';
    section.setAttribute('data-cjs-brand-performance-upgrades', '');

    var header = document.createElement('div');
    header.className = 'cjs-brand-page__section-header';
    header.innerHTML =
      '<div><p class="cjs-brand-page__section-eyebrow">Performance Upgrades</p><h2>' +
      (brandNames[path] || 'Suspension') +
      ' Performance Upgrades</h2></div>' +
      '<div class="cjs-brand-page__section-copy rte"><p>Only confirmed CJSUSPENSION upgrade options are shown. Exact compatibility is checked against the model and generation before work begins.</p></div>';

    var grid = document.createElement('div');
    grid.className = 'cjs-brand-performance-upgrades__grid';
    section.appendChild(header);
    section.appendChild(grid);

    var information = content.querySelector('.cjs-brand-page__information');
    var faq = content.querySelector('.cjs-brand-page__faq');
    var anchor = information || faq;
    if (anchor) content.insertBefore(section, anchor);
    else content.appendChild(section);

    return section;
  }

  function getGrid() {
    var section = ensurePerformanceSection();
    return section ? section.querySelector('.cjs-brand-performance-upgrades__grid') : null;
  }

  function normaliseLegacyCards() {
    var grid = getGrid();
    var aliases = headingAliases[path];
    if (!grid) return;

    if (aliases) {
      Array.prototype.slice.call(grid.querySelectorAll('.cjs-brand-performance-upgrades__card')).forEach(function (card) {
        var heading = card.querySelector('h3');
        if (!heading) return;
        var replacement = aliases[String(heading.textContent || '').trim()];
        if (replacement) heading.textContent = replacement;
      });
    }

    var seen = {};
    Array.prototype.slice.call(grid.querySelectorAll('.cjs-brand-performance-upgrades__card')).forEach(function (card) {
      var heading = card.querySelector('h3');
      if (!heading) return;
      var title = String(heading.textContent || '').trim();
      if (!title) return;
      if (seen[title]) card.remove();
      else seen[title] = true;
    });
  }

  function ensureAdditionalCards() {
    var cardsToAdd = additionalCards[path];
    var grid = getGrid();
    if (!cardsToAdd || !cardsToAdd.length || !grid) return;

    normaliseLegacyCards();
    cardsToAdd.forEach(function (config) {
      var exists = Array.prototype.some.call(grid.querySelectorAll('.cjs-brand-performance-upgrades__card h3'), function (heading) {
        return String(heading.textContent || '').trim() === config.title;
      });
      if (!exists) grid.appendChild(createCard(config));
    });
  }

  function updateCanonicalCardContent() {
    var cardsToAdd = additionalCards[path];
    var grid = getGrid();
    if (!cardsToAdd || !grid) return;

    cardsToAdd.forEach(function (config) {
      var card = Array.prototype.find.call(grid.querySelectorAll('.cjs-brand-performance-upgrades__card'), function (candidate) {
        var heading = candidate.querySelector('h3');
        return heading && String(heading.textContent || '').trim() === config.title;
      });
      if (!card) return;

      var label = card.querySelector('.cjs-brand-performance-upgrades__label');
      if (label) label.textContent = config.label;

      var text = card.querySelector('.cjs-brand-performance-upgrades__text');
      if (text) text.textContent = config.text;

      var models = card.querySelector('.cjs-brand-performance-upgrades__models');
      if (models && (config.models || config.modelsHtml)) {
        models.innerHTML = '<strong>Confirmed range:</strong>' + (config.modelsHtml ? config.modelsHtml : ' ' + config.models);
      }
    });
  }

  function applyActions() {
    var pageMap = cardActions[path];
    var grid = getGrid();
    if (!pageMap || !grid) return false;

    Array.prototype.slice.call(grid.querySelectorAll('.cjs-brand-performance-upgrades__card')).forEach(function (card) {
      var heading = card.querySelector('h3');
      if (!heading) return;
      var actions = pageMap[String(heading.textContent || '').trim()];
      if (!actions || !actions.length) return;

      Array.prototype.slice.call(card.querySelectorAll(':scope > .cjs-brand-page__card-link, :scope > .cjs-brand-performance-upgrades__actions')).forEach(function (node) {
        node.remove();
      });

      var wrap = document.createElement('div');
      wrap.className = 'cjs-brand-performance-upgrades__actions';
      actions.forEach(function (action) {
        var link = document.createElement('a');
        link.className = 'cjs-brand-page__card-link';
        link.href = action.href;
        link.innerHTML = '<span>' + action.label + '</span><span aria-hidden="true">→</span>';
        wrap.appendChild(link);
      });
      card.appendChild(wrap);
      card.setAttribute('data-cjs-multi-cta-ready', '');
    });

    return true;
  }

  function run() {
    path = String(window.location.pathname || '').toLowerCase();
    if (!cardActions[path]) return;

    addStyles();
    ensurePerformanceSection();
    normaliseLegacyCards();
    ensureAdditionalCards();
    updateCanonicalCardContent();
    applyActions();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  window.setTimeout(run, 100);
  window.setTimeout(run, 500);
  window.setTimeout(run, 1400);
  document.addEventListener('shopify:section:load', run);
})();